import React, { useState, useEffect,useRef} from 'react';
import { configData } from "../config";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import MinicartLength from './MinicartLength';
import ReactDOM from "react-dom/client";
import Loading from './Loading';

function PaypalPaymentNotify() {
    
    
    const app_url = configData.APP_URL;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const fetchData = async (params) => {
    try {
        const order_id = localStorage.getItem('order_id');
        const drupal_orderid = localStorage.getItem('drupal_orderid');
      
        
       const response = await fetch(app_url+'smwwcommercepayment/notifypaypalpayment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          params:params,
          order_id:order_id,
          drupal_orderid:drupal_orderid
         
        }),
        });
        const data = await response.json();
        if(data.data.result == "Success") {
          localStorage.removeItem("order_id");
          localStorage.removeItem("drupal_orderid");
          navigate("/smww/checkout/thankyou/"+data.data.drupal_orderid);
        }
      } 
     catch (error) {
      console.error(error);
    }finally {
            
          }
  };

  

  useEffect(() => {
    fetchData(searchParams.toString());
  }, [searchParams]);
      return (
        <><div style={{ margin: "0 auto",maxWidth: 1170,width: "100%",textAlign: "center",fontSize: "35px",
          color: "#000",
          fontWeight: "900",
          marginTop: "20px" }}>Please wait until your order is complete.</div><Loading /></>
      );
}

export default PaypalPaymentNotify;